import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { filter, get, isEmpty, map } from 'lodash';
import { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Annunciator } from '../annunciator';
import { Loader } from '../loader';
import { DataTableRow } from './data-table-row';
import useStyles from './styles';

interface DataTableProps {
  hits: Record<string, any>[];
  columns: Record<string, any>[];
  expandable?: boolean;
  expanded?: (item: Record<string, any>) => ReactNode;
  isLoading?: boolean;
  expandCallback?: (item: Record<string, any>) => void;
}

export const DataTable: ComponentType<DataTableProps> = ({
  expandable,
  hits,
  columns,
  expanded,
  isLoading = false,
  expandCallback,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const filteredColumns = filter(columns, (x) => !get(x, 'hidden', false));

  const tableHead = () => {
    if (!isEmpty(hits)) {
      return (
        <TableHead className={classes.thead}>
          <TableRow>
            {map(filteredColumns, (col, index) => (
              <TableCell className={classes.cell} width={col.width} key={index}>
                {t(col.labelKey, col.label)}
              </TableCell>
            ))}
            {expandable && <TableCell className={classes.cell} width={73} />}
          </TableRow>
        </TableHead>
      );
    }
  };

  const view = () => {
    if (isLoading)
      return (
        <TableBody className={classes.tbody}>
          <TableRow>
            <TableCell colSpan={columns.length + (expandable ? 1 : 0)}>
              <Loader minHeight="50vh" />
            </TableCell>
          </TableRow>
        </TableBody>
      );

    if (isEmpty(hits))
      return (
        <TableBody className={classes.tbody}>
          <TableRow>
            <TableCell colSpan={columns.length + (expandable ? 1 : 0)}>
              <Annunciator
                title={t('results.not.found.title', 'По вашему запросу ничего не найдено')}
                text={t('results.not.found.text', 'попробуйте поменять фильтр и попробовать снова')}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      );

    return (
      <TableBody className={classes.tbody}>
        {map(hits, (item, index) => (
          <DataTableRow
            item={item}
            columns={filteredColumns}
            expandable={expandable}
            renderExpanded={expanded}
            key={index}
            expandCallback={expandCallback}
          />
        ))}
      </TableBody>
    );
  };

  return (
    <Table>
      {tableHead()}
      {view()}
    </Table>
  );
};
